module.exports = __webpack_public_path__ + "static/media/red-hot-deals-rsr-mobile.02c32423.jpg";